import { render, staticRenderFns } from "./DisableIntegrationModal.vue?vue&type=template&id=eb2a4316&"
import script from "./DisableIntegrationModal.vue?vue&type=script&lang=js&"
export * from "./DisableIntegrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports